(() => {
  const RR = window.RR || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function money(cents) {
    const fmt = RR.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return two;
    });
  }
  function img(url, w) {
    if (!url) return '';
    try { const u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }

  /* ---------- overlays ---------- */
  let lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('input[type=search], button, a');
    setTimeout(() => f && f.focus(), 60);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.minicart.is-open, .mdrawer.is-open, .search.is-open, .rr-modal.is-open')) document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.minicart.is-open, .mdrawer.is-open, .search.is-open, .rr-modal.is-open').forEach(closeLayer);
  });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-menu],[data-close-menu],[data-open-search],[data-close-search],[data-open-cart],[data-close-cart],[data-open-modal],[data-close-modal]');
    if (!t) return;
    if (t.matches('[data-open-menu]')) openLayer($('#MobileMenu'));
    else if (t.matches('[data-close-menu]')) closeLayer($('#MobileMenu'));
    else if (t.matches('[data-open-search]')) { closeLayer($('#MobileMenu')); openLayer($('#SearchOverlay')); }
    else if (t.matches('[data-close-search]')) closeLayer($('#SearchOverlay'));
    else if (t.matches('[data-open-cart]')) { e.preventDefault(); openCart(); }
    else if (t.matches('[data-close-cart]')) closeLayer($('#MiniCart'));
    else if (t.matches('[data-open-modal]')) openLayer(document.getElementById(t.dataset.openModal));
    else if (t.matches('[data-close-modal]')) closeLayer(t.closest('.rr-modal'));
  });

  /* ---------- cart drawer ---------- */
  const drawer = $('#MiniCart');
  async function getCart() { return (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); }
  function setCount(n) { $$('[data-cart-count]').forEach((el) => (el.textContent = n > 0 ? n : '')); }
  function renderCart(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    const items = $('[data-mc-items]', drawer), foot = $('[data-mc-foot]', drawer), ship = $('[data-mc-ship]', drawer);
    if (!cart.item_count) {
      items.innerHTML = `<div class="minicart__empty"><p>Your bag is empty.</p><a class="btn" href="${RR.routes?.root || '/'}collections/all">Continue shopping</a></div>`;
      foot.hidden = true; ship.hidden = true; return;
    }
    items.innerHTML = cart.items.map((it, i) => `
      <div class="mc-line" data-line="${i + 1}">
        <a class="mc-line__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(img(it.image, 240))}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div>
          <a class="mc-line__name" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? '' : `<div class="mc-line__opts">${esc(it.variant_title || '')}</div>`}
          <div class="qty mc-line__qty">
            <button type="button" class="qty__btn" data-mc-qty="${it.quantity - 1}" aria-label="Decrease">−</button>
            <span class="qty__val" style="display:inline-block;line-height:30px">${it.quantity}</span>
            <button type="button" class="qty__btn" data-mc-qty="${it.quantity + 1}" aria-label="Increase">+</button>
          </div>
        </div>
        <div>
          <div class="mc-line__price">${money(it.final_line_price)}</div>
          ${it.original_line_price > it.final_line_price ? `<s style="font-size:12px;color:var(--muted);display:block;text-align:right">${money(it.original_line_price)}</s>` : ''}
          <button type="button" class="mc-line__remove" data-mc-qty="0">Remove</button>
        </div>
      </div>`).join('');
    $('[data-mc-subtotal]', drawer).textContent = money(cart.total_price);
    foot.hidden = false;
    const goal = Number(RR.freeShip || 0);
    if (goal > 0) {
      const left = goal - cart.total_price;
      const pct = Math.min(100, Math.round((cart.total_price / goal) * 100));
      ship.innerHTML = (left > 0 ? `You're <b>${money(left)}</b> away from free shipping.` : `You've unlocked <b>free shipping</b>.`) + `<div class="minicart__bar"><i style="width:${pct}%"></i></div>`;
      ship.hidden = false;
    } else ship.hidden = true;
  }
  async function openCart() {
    if (!drawer) { location.href = '/cart'; return; }
    openLayer(drawer);
    drawer.classList.add('is-loading');
    try { renderCart(await getCart()); } finally { drawer.classList.remove('is-loading'); }
  }
  drawer && drawer.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-mc-qty]');
    if (!b) return;
    const line = Number(b.closest('[data-line]').dataset.line);
    drawer.classList.add('is-loading');
    try {
      const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: Math.max(0, Number(b.dataset.mcQty)) }) });
      renderCart(await res.json());
    } finally { drawer.classList.remove('is-loading'); }
  });

  /* ---------- wishlist (per-browser) ---------- */
  const FAV = 'rr_favs';
  const favs = (() => { try { return new Set(JSON.parse(localStorage.getItem(FAV) || '[]')); } catch (e) { return new Set(); } })();
  const paintFavs = () => $$('[data-fav]').forEach((b) => { const on = favs.has(b.dataset.fav); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    favs.has(b.dataset.fav) ? favs.delete(b.dataset.fav) : favs.add(b.dataset.fav);
    try { localStorage.setItem(FAV, JSON.stringify([...favs])); } catch (err) {}
    paintFavs();
  }, true);
  paintFavs();

  /* ---------- card swatches ---------- */
  function cardSwatch(sw) {
    const card = sw.closest('[data-card]');
    $$('.prod-card__sw b', card).forEach((b) => b.classList.toggle('is-on', b === sw));
    const im = $('[data-card-img]', card);
    if (im && sw.dataset.swImg) { im.removeAttribute('srcset'); im.src = sw.dataset.swImg; }
  }
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.prod-card__sw b');
    if (!sw) return;
    e.preventDefault(); cardSwatch(sw);
  });
  document.addEventListener('keydown', (e) => {
    const sw = e.target.closest && e.target.closest('.prod-card__sw b');
    if (sw && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); cardSwatch(sw); }
  });

  /* ---------- predictive search ---------- */
  const sInput = $('[data-search-input]'), sOut = $('[data-search-results]');
  let sTimer, sCtl;
  sInput && sInput.addEventListener('input', () => {
    clearTimeout(sTimer);
    const q = sInput.value.trim();
    if (q.length < 2) { sOut.innerHTML = ''; return; }
    sTimer = setTimeout(async () => {
      sCtl && sCtl.abort(); sCtl = new AbortController();
      try {
        const url = `${(RR.routes && RR.routes.predictive) || '/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last`;
        const data = await (await fetch(url, { signal: sCtl.signal })).json();
        const prods = data.resources?.results?.products || [], cols = data.resources?.results?.collections || [];
        if (!prods.length && !cols.length) { sOut.innerHTML = `<p class="search__label">No results for “${esc(q)}”</p>`; return; }
        sOut.innerHTML =
          (cols.length ? `<p class="search__label">Collections</p><div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:22px">${cols.map((c) => `<a class="facets__chip" style="padding:8px 14px" href="${esc(c.url)}">${esc(c.title)}</a>`).join('')}</div>` : '') +
          (prods.length ? `<p class="search__label">Products</p><div class="search__grid">${prods.map((p) => `
            <a class="card-product" href="${esc(p.url)}">
              <div class="card-product__media">${p.image ? `<img src="${esc(img(p.image, 500))}" alt="${esc(p.title)}" loading="lazy">` : ''}</div>
              <div class="prod-card__name">${esc(p.title)}</div>
              <div class="prod-card__price"><b>${money(Math.round(parseFloat(p.price) * 100))}</b></div>
            </a>`).join('')}</div>` : '') +
          `<p style="margin-top:22px"><a class="btn btn--ghost" href="/search?type=product&q=${encodeURIComponent(q)}">See all results</a></p>`;
      } catch (err) { if (err.name !== 'AbortError') sOut.innerHTML = ''; }
    }, 220);
  });

  /* ---------- product page ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const product = JSON.parse($('[data-product-json]', pdp).textContent);
    const form = $('[data-pdp-form]', pdp);
    const idInput = $('[data-variant-id]', pdp);
    const addBtn = $('[data-add]', pdp), addLabel = $('[data-add-label]', pdp), err = $('[data-add-error]', pdp);
    const priceEl = $('[data-pdp-price]', pdp), wasEl = $('[data-pdp-was]', pdp), offerEl = $('[data-pdp-offer]', pdp);
    const sticky = $('[data-pdp-sticky]', pdp), stickySel = $('[data-sticky-sel]', pdp);
    const nOpts = product.options.length;
    const sizeIdx = product.options.findIndex((o) => /^size$/i.test(o.name || o));
    let sizeChosen = sizeIdx < 0 || !!form.querySelector(`input[data-opt="${sizeIdx}"]:checked`);

    const selected = () => Array.from({ length: nOpts }, (_, i) => { const c = form.querySelector(`input[data-opt="${i}"]:checked`); return c ? c.value : null; });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    function markAvailability(opts) {
      for (let i = 0; i < nOpts; i++) {
        $$(`input[data-opt="${i}"]`, form).forEach((inp) => {
          const test = opts.slice(); test[i] = inp.value;
          const v = product.variants.find((x) => x.available && x.options.every((o, k) => test[k] === null || o === test[k]));
          inp.closest('label').classList.toggle('is-oos', !v);
        });
      }
    }
    function showMedia(v) {
      if (!v || !v.featured_media) return;
      const shot = pdp.querySelector(`[data-media-id="${v.featured_media.id}"]`);
      if (!shot) return;
      const media = $('[data-pdp-media]', pdp);
      if (window.matchMedia('(max-width: 749px)').matches) media.scrollTo({ left: shot.offsetLeft, behavior: 'smooth' });
      else {
        const first = media.firstElementChild;
        if (shot !== first) media.insertBefore(shot, first);
      }
    }
    function update(fromUser) {
      const opts = selected();
      // size not picked yet: price/availability from the first variant matching the other options
      const v = findVariant(opts) || (opts.includes(null) ? product.variants.find((x) => x.options.every((o, i) => opts[i] === null || o === opts[i])) : null);
      $$('[data-opt-val]', pdp).forEach((el) => (el.textContent = opts[Number(el.dataset.optVal)] || ''));
      markAvailability(opts);
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      wasEl.hidden = !sale; offerEl.hidden = !sale;
      if (sale) { wasEl.textContent = money(v.compare_at_price); offerEl.textContent = `Save ${Math.round((1 - v.price / v.compare_at_price) * 100)}%`; }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (stickySel) stickySel.textContent = v.title;
      if (fromUser) {
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
        showMedia(v);
      }
    }
    form.addEventListener('change', (e) => {
      const inp = e.target.closest('input[data-opt]');
      if (!inp) return;
      if (inp.closest('.sizes')) { sizeChosen = true; const h = $('[data-opt-hint]', pdp); h && (h.textContent = ''); }
      update(true);
    });
    $$('[data-qty]', pdp).forEach((b) => b.addEventListener('click', () => {
      const q = $('[data-qty-input]', pdp); q.value = Math.max(1, Number(q.value || 1) + Number(b.dataset.qty));
    }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      err.hidden = true;
      if (!sizeChosen) { err.textContent = 'Please select a size.'; err.hidden = false; return; }
      addBtn.disabled = true; const prev = addLabel.textContent; addLabel.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        await openCart();
      } catch (ex) { err.textContent = ex.message; err.hidden = false; }
      finally { addBtn.disabled = false; addLabel.textContent = prev; update(false); }
    });
    sticky && $('[data-sticky-add]', sticky).addEventListener('click', () => {
      if (!sizeChosen) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); err.textContent = 'Please select a size.'; err.hidden = false; return; }
      form.requestSubmit();
    });
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', !show);
      }).observe(addBtn);
    }
    const media = $('[data-pdp-media]', pdp), dots = $$('[data-pdp-dots] i', pdp);
    media && dots.length && media.addEventListener('scroll', () => {
      const i = Math.round(media.scrollLeft / media.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    }, { passive: true });
    update(false);
  }

  /* ---------- recommendations ---------- */
  $$('[data-recs]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; paintFavs(); }
    } catch (e) {}
  });

  /* ---------- facets: one open at a time ---------- */
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('facets__item') || !d.open) return;
    $$('.facets__item[open]').forEach((o) => o !== d && (o.open = false));
  }, true);
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.facets__item')) $$('.facets__item[open]').forEach((o) => (o.open = false));
  });
})();
